import React, { useState } from "react";
import ReactDOM from "react-dom";
import { ethers } from "ethers";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./PreCard.scss";
import { useWallet } from "../../../contexts/WalletContext";
import { useAuth } from "../../../contexts/AuthContext";
import { formatPrice } from "../Market/Market";

const PreCard = ({
  item,
  onClick,
  ETH,
  tokens,
  onBuy,
  marketAddress,
  marketAbi,
  useFormattedPrice = true,
}) => {
  const {
    ethAddress: walletAddress,
    connectWallet,
    provider,
    isConnecting,
  } = useWallet();
  const { ethAddress: authEthAddress } = useAuth();

  const [showWalletModal, setShowWalletModal] = useState(false);

  const activeAddress = walletAddress || authEthAddress;

  const handleBuy = async (e) => {
    e.stopPropagation();

    if (onBuy) {
      onBuy(item);
      return;
    }

    if (!activeAddress) {
      toast.warn("⚠️ Please connect your wallet first!");
      setShowWalletModal(true);
      return;
    }

    try {
      const web3Provider = new ethers.BrowserProvider(
        provider || window.ethereum,
      );
      const signer = await web3Provider.getSigner();

      const contractAddr = item.marketAddress || marketAddress;
      const contractABI = item.marketABI || marketAbi;
      const contract = new ethers.Contract(contractAddr, contractABI, signer);

      let totalValue;
      let buyId;

      if (item.marketAddress) {
        totalValue = ethers.toBigInt(item.pricePerToken);
        buyId = item.listingId;
      } else {
        totalValue = ethers.parseEther(item.price?.toString() || "0");
        buyId = item.id;
      }

      const balance = await web3Provider.getBalance(activeAddress);
      if (balance < totalValue) {
        toast.error("❌ Not enough ETH to buy this NFT");
        return;
      }

      const tx = await contract.buy(buyId, 1, { value: totalValue });
      await tx.wait();

      toast.success("✅ Purchase successful!");
    } catch (err) {
      console.error("Purchase error:", err);
      toast.error("❌ Purchase failed!");
    }
  };

  const handleConnectWallet = async () => {
    try {
      await connectWallet();
      setShowWalletModal(false);
    } catch (err) {
      console.error("Wallet connection failed:", err);
      toast.error(err.message || "Failed to connect to wallet");
    }
  };

  return (
    <>
      <div className="PreCard" onClick={() => onClick && onClick(item)}>
        <div className="PreCard-canvas2">
          <img
            src={item.prev || item.preview}
            alt={item.name}
            className="pre-modal-img"
            draggable="false"
            style={{ width: "100%", height: "100%" }}
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>

        <div className="info font-body2">
          <div className="info-size2">
            <p className="info-p">
              <strong className="info-name">{item.name}</strong>{" "}
              <span className="info-size">{item.year}</span>
            </p>
          </div>
        </div>

        <div className="bottom">
          <p className="info-size">{item.size} Size</p>
          <span className="type text-small info-size">{item.type}</span>
        </div>
        <div className="info-size-div">
          {/* <p className="info-size">
            {useFormattedPrice
              ? `${item.price} ${ETH}`
              : `${item.price} ${ETH}`}
          </p> */}
          <p className="info-size">
            {item.price} {ETH}
          </p>
          <p className="info-tokens">
            {item.quantity} {tokens}
          </p>
        </div>
        <button className="buy-btn" onClick={handleBuy}>
          Buy
        </button>
      </div>

      {showWalletModal &&
        ReactDOM.createPortal(
          <div
            className="modal-overlay-global"
            onClick={() => setShowWalletModal(false)}
          >
            <div
              className="modal-box-global"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>Connect Your Wallet</h3>
              <p>You need to connect your wallet to continue.</p>
              <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                <button onClick={handleConnectWallet}>
                  {isConnecting ? "Connecting..." : "Connect Wallet"}
                </button>
                <button onClick={() => setShowWalletModal(false)}>Close</button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};

export default PreCard;
